import KumosearchError from "./KumosearchError";

export default class HTTPError extends KumosearchError {}
